export default __webpack_public_path__ + "static/badge-color-dark-f177e9d229bad79f07c3079d6e889756.png";